class NumberUtils {
  static completeNumberWithLeftZero(value: number, finalSize: number) {
    return String(value).padStart(finalSize, '0')
  }
}

export default NumberUtils
